(() => {
  if (customElements.get('hzw-key-features')) return;
  customElements.define('hzw-key-features', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.trigger = this.querySelector('button.hzw-kf__trigger');
      if (!this.trigger) return;
      this.trigger?.addEventListener('click', () => this.open(), options);
      this.querySelector('.hzw-kf__summary')?.addEventListener('click', event => {
        if (!event.target.closest('a,button,input') && !window.getSelection()?.toString()) this.open();
      }, options);
    }
    open() {
      if (this.dialog?.open) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.dialog = template.content.firstElementChild.cloneNode(true);
      document.body.append(this.dialog);
      const dialog = this.dialog;
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.trigger.setAttribute('aria-expanded', 'true');
      dialog.querySelector('.hzw-kf-dialog__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('keydown', event => {
        // Keep Escape within this nested dialog, rather than closing the product popup too.
        if (event.key === 'Escape') event.stopPropagation();
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => this.cleanup(), { once: true });
      dialog.showModal();
    }
    cleanup() {
      if (!this.dialog) return;
      document.documentElement.style.overflow = this.previousOverflow;
      this.dialog.remove();
      this.dialog = null;
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.isConnected) this.trigger?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.cleanup();
    }
  });
})();
